import { UX_MODE, AuthAdapter } from '@web3auth/auth-adapter';
import { OPENLOGIN_NETWORK } from '@web3auth/openlogin-adapter';
import { Web3AuthNoModal } from '@web3auth/no-modal';

export function createOpenloginAdapter(privateKeyProvider) {
	const authAdapter = new AuthAdapter({
		privateKeyProvider,
		adapterSettings: {
			uxMode: UX_MODE.REDIRECT
		}
	});
	return authAdapter;
}

export function createWeb3Auth(chainConfig, privateKeyProvider) {
	return new Web3AuthNoModal({
		clientId: process.env.NEXT_PUBLIC_WEB3AUTH_CLIENT_ID,
		chainConfig,
		web3AuthNetwork: OPENLOGIN_NETWORK.MAINNET,
		privateKeyProvider
	});
}